import { IAgentQuoteData } from 'Feature/PageContent/Models/MyInsightsModel';
import { useAgentQuoteData } from 'Foundation/User/QuoteDataContext';
import { useEffect, useState } from 'react';
import { ExpandableCard } from '@lmig/lmds-react-card';
import { Heading } from '@lmig/lmds-react-typography';
import { SimpleTable } from 'Foundation/Common/SimpleTable';
import { useUserData } from 'Foundation/User/UserContext';
import { ISimpleInputTableItem, SimpleInputTable } from 'Foundation/Common/SimpleInputTable';

export function UserInfoQuoteData() {
  const { agentQuoteData } = useAgentQuoteData();
  const { userData } = useUserData();
  const { getAgentQuoteData, updateAgentQuoteData } = useAgentQuoteData();

  const convertQuoteDataToTableData = (quoteData: IAgentQuoteData | null | undefined): ISimpleInputTableItem[] => {
    if (!quoteData) return [];
    return Object.entries(quoteData)
      .map(([key, value]) => ({
        name: key,
        value: String(value),
      }))
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter((item) => item.name !== 'default');
  };

  const updateUserQuoteData = (tableData: ISimpleInputTableItem[]) => {
    updateAgentQuoteData(convertTableDataToQuoteData(tableData));
  };

  const [agentQuoteTableData, setAgentQuoteTableData] = useState<ISimpleInputTableItem[]>(
    convertQuoteDataToTableData(agentQuoteData),
  );

  useEffect(() => {
    const newUserQuoteDataValue = convertQuoteDataToTableData(agentQuoteData);
    if (JSON.stringify(agentQuoteTableData) !== JSON.stringify(newUserQuoteDataValue)) {
      setAgentQuoteTableData(newUserQuoteDataValue);
    }
  }, [agentQuoteData]);

  const convertTableDataToQuoteData = (tableData: ISimpleInputTableItem[]): IAgentQuoteData => {
    let newQuoteData = {} as IAgentQuoteData;
    tableData.forEach((item) => {
      newQuoteData[item.name as keyof IAgentQuoteData] = item.value as string;
    });
    return newQuoteData;
  };
  
  return userData ? (
    <ExpandableCard
    defaultExpanded={false}
      cardTitle={
        <Heading type="h4-light">
          Quote Data {!userData.isAgent() && <span style={{ color: 'blue' }}>({userData.dpecid})</span>}
        </Heading>
      }
    >
      <div className="container">
        {userData.isMockingAgent ? (
          <SimpleInputTable
            tableObject={agentQuoteTableData}
            onSubmit={updateUserQuoteData}
            onReset={() => getAgentQuoteData(true)}
            disabledFields={[
              'UserID',
              'MultiLocInd',
              'PrimartyState',
              'MultiStateInd',
              'PrimaryRater',
              'LastQuoteDate',
              'LastIssueDate',
            ]}
          />
        ) : (
          <SimpleTable tableObject={agentQuoteTableData} nameProp="name" valueProp="value" />
        )}
      </div>
    </ExpandableCard>
  ) : (
    <></>
  );
}